<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">
        
        <v-row class="py-1 px-5">
          <v-col cols="12" md="12">
            <v-row>
              <v-col cols="12" class="px-5" PANNELS>
                <v-card NotificationPanel :loading="loading">
                  <v-card-text class="py-0">
                    <v-row>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" class="text-center" TITLE>
                            <v-icon size="40" color="secondary">people</v-icon>
                          </v-col>
                          <v-col cols="10" TITLE>
                            <div :class="`${arabic?'arFont':'enFont'} black--text`">جميع المستخدمين</div>
                            <div :class="`${arabic?'arFont':'enFont'} grey--text`">ادارة مستخدمين المنصة</div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12" class="text-center py-0" BTN>
                        <v-row class="align-center">
                          <v-col cols="12" md="4" ADD-USERS>
                            <div>
                              <v-text-field
                                v-model="search_term"
                                :class="`${arabic?'arFont':'enFont'}`"
                                label="بحث"
                                outlined
                                dense
                                clearable
                                @change="filterLeads()"
                                hide-details
                              >
                              </v-text-field>
                            </div>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-1" FILTER>
                            <v-menu
                              v-model="menu1"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="fromDate"
                                  label="من تاريخ"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  :loading="loading"
                                  outlined
                                  hide-details
                                  dense
                                  :class="`${arabic?'arFont':'enFont'}`"

                                  @change="filterLeads()"
                                  clearable
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="fromDate"
                                @change="filterLeads()"
                                @input="menu1 = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-1" FILTER>
                            <v-menu
                              v-model="menu2"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="toDate"
                                  label="الى تاريخ"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  :loading="loading"
                                  :class="`${arabic?'arFont':'enFont'}`"
                                  hide-details
                                  outlined
                                  @change="filterLeads()"
                                  dense
                                  clearable
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="toDate"
                                @change="filterLeads()"
                                @input="menu2 = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="12" md="2" :class="`${arabic?'arFont':'enFont'} text-center pa-2`">
                            <span v-if="resource.data" :class="`${arabic?'arFont':'enFont'}`"> المستخدمين ({{ resource.counter }})</span>
                          </v-col>
                          <v-col cols="12" md="10" :class="`${arabic?'arFont':'enFont'}`">
                            <Paging 
                              :resourceSettings="resourceSettings" 
                              :resource="resource"
                              @loadResource="loadResource"
                              @pageByNumber="pageByNumber"
                            />
                          </v-col>
                          <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`">
                            <v-expansion-panels focusable>
                              <v-expansion-panel v-for="(r, i) in resource.data" :key="'resource-'+i"  style="cursor:pointer;">
                                <v-expansion-panel-header>
                                  <v-row class="pa-0 align-center">
                                    <v-col cols="12" md="3" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 font-weight-bold`">
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <span v-bind="attrs" v-on="on">{{r.name}}</span>
                                        </template>
                                        <div class="text-center">
                                          <div><img :src="r.image"></div>
                                          <div :class="`${arabic?'arFont':'enFont'}`">{{r.name}}</div>
                                          <div :class="`${arabic?'arFont':'enFont'}`">{{r.email}}</div>
                                          <div :class="`${arabic?'arFont':'enFont'}`">{{r.provider}}</div>
                                          <div :class="`${arabic?'arFont':'enFont'}`">{{r.role}}</div>
                                          <div :class="`${arabic?'arFont':'enFont'}`">{{r.countries}}</div>
                                          <div :class="`${arabic?'arFont':'enFont'}`">{{r.departments}}</div>
                                        </div>
                                      </v-tooltip>
                                    </v-col>
                                    <v-col cols="12" md="3" :class="`${arabic?'arFont':'enFont'} pa-0 py-1`">
                                      <div style="font-size:11px;" class="py-1">{{r.email}}</div>
                                      <div style="font-size:11px;" class="py-1">{{r.phone}}</div>
                                    </v-col>
                                    <v-col cols="12" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 adminSwitch text-left`">
                                      <v-switch @change="updateResource(r)" 
                                        hide-details 
                                        :class="`${arabic?'arFont':'enFont'}`" 
                                        :name="i18n.access"
                                        :label="i18n.access" v-model="r.access"></v-switch>
                                    </v-col>
                                    <v-col cols="12" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 adminSwitch text-left`">
                                      <v-switch @change="updateResource(r)" 
                                        hide-details 
                                        :class="`${arabic?'arFont':'enFont'}`" 
                                        :name="i18n.onboarding"
                                        label="On Boarding" v-model="r.onboarding"></v-switch>
                                    </v-col>
                                    <v-col cols="11" md="3" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 adminSwitch text-left`">
                                      <v-select
                                        :items="roles"
                                        v-model="r.role"
                                        :label="i18n.userRole"
                                        :name="i18n.userRole"
                                        outlined
                                        :disabled="user.role != 'master'"
                                        :readonly="user.role != 'master'"
                                        hide-details
                                        dense
                                        @change="updateResource(r)"
                                        item-value="slug"
                                        :class="`${arabic?'arFont':'enFont'}`"
                                      >
                                        <template v-slot:selection="{ attr, on, item, selected }">
                                          <span
                                            v-bind="attr"
                                            :input-value="selected"
                                            v-on="on"
                                            :class="`${arabic?'arFont':'enFont'}`"
                                          >
                                            {{item.text}}
                                          </span>
                                        </template>
                                        <template v-slot:item="{ item }">
                                          <span
                                            :class="`${arabic?'arFont':'enFont'}`"
                                          >
                                            {{item.text}}
                                          </span>
                                        </template>
                                      </v-select>
                                    </v-col>
                                    <v-col cols="1" md="1" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 adminSwitch text-center`">
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <span v-bind="attrs" v-on="on">
                                            <v-avatar
                                              size="10"
                                              :color="r.online?'success':'error'"
                                            >
                                            </v-avatar>
                                          </span>
                                        </template>
                                        <div :class="`${arabic?'arFont':'enFont'}`">{{getFormat(r.updated_at)}}</div>
                                      </v-tooltip>
                                    </v-col>
                                  </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  <v-divider class="pb-3"></v-divider>
                                  <v-row class="pa-0 align-center">
                                    <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'} pa-1 adminSwitch text-right`">
                                      <div>رقم الهاتف</div>
                                      <div>{{r.phone}}</div>
                                    </v-col>
                                    <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'} pa-1 adminSwitch text-right`">
                                      <div>WHATSAPP</div>
                                      <div>{{r.whatsapp}}</div>
                                    </v-col>
                                    <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'} pa-1 adminSwitch text-right`">
                                      <div>طرق التسويق والاعلانات </div>
                                      <div>{{r.ads}}</div>
                                    </v-col>
                                    <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'} pa-1 adminSwitch text-right`">
                                      <div>متوسط عدد الطلبات اسبوعياً</div>
                                      <div>{{r.sales}}</div>
                                    </v-col>
                                    <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'} pa-1 adminSwitch text-right`">
                                      <div>باع سابقا في</div>
                                      <div>{{r.countries_history}}</div>
                                    </v-col>
                                    <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'} pa-1 adminSwitch text-right`">
                                      <div>رابط حساب الفيس بوك</div>
                                      <div>{{r.facebook_link}}</div>
                                    </v-col>
                                    <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'} pa-1 adminSwitch text-right`">
                                      <div>بلد الاقامة</div>
                                      <div v-if="r.country">{{r.country.name}}</div>
                                    </v-col>
                                    <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'} pa-1 adminSwitch text-right`">
                                      <div>المبلغ المستثمر في الاعلانات </div>
                                      <div>{{r.current_budget}}</div>
                                    </v-col>
                                    <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'} pa-1 adminSwitch text-right`">
                                      <div>الوقت المناسب للأتصال</div>
                                      <div>{{r.time_to_call}}</div>
                                    </v-col>

                                    <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} pa-1 adminSwitch text-left`">
                                      <v-btn color="success" block text @click="updateResource(r)">
                                        <v-icon left>save</v-icon>
                                        <span>تحديث</span>
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                            
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Search from '@/components/Search'
import Paging from '@/components/Paging'
import Notifications from '@/components/Notifications'
import { format, render, cancel, register } from 'timeago.js';

export default {
  components: { Paging, Notifications },
  data() {
    return {
      loading:false,
      dialog:false,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys:[
        
      ],
      resourceSettings:{
        resourceName:null,
        search:false,
        create:false,
        pagination:true,
      },
      newResource:{},
      editing:false,
      deleting:false,
      search_term:null,
      menu1:false,
      fromDate:null,
      menu2:false,
      toDate:null,
    }
  },
  methods: {
    getFormat(d){
      return format(d)
    },
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    clipboardSuccessHandler (){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler () {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path, page:`?page=${n}` + this.buildFilter()})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + `/search?page=${n}`, value:this.search})
        }
        this.loading = false
      })
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    buildFilter(){
      let filter = ``
      if(this.search_term) {
        filter += `&filter[search]=${this.search_term}`
      }
      if(this.fromDate && this.toDate) {
        filter += `&filter[from]=${this.fromDate}&filter[to]=${this.toDate}`
      }
      return filter
    },
    async filterLeads(){
      await this.loadResource()
    },
    firstLoad(){
      if(this.user) {
      }
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path + '?' + this.buildFilter()})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        }
        this.loading = false
        res()
      })
    },
    async updateResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        // console.log(r)
        await this.$store.dispatch('putResource', {resource:this.$route.path + `/${r.id}`, value:r})
        this.loadResource()
        this.loading = false
      })
    },
    showPannel(v){
      this[v] = true
      let all = this.subitems.map(x=>x.value)
      all.filter(x=>x!=v).forEach(x=>this[x] = false)
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.i18n[this.$route.path.replace('/', '')]
    }
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    this.setResourceName()
    await this.loadResource()
  },
}
</script>

<style>

</style>